export const CategoryType = {
  flight: 'flight',
  hotel: 'hotel',
  train: 'train',
  common: 'common',
  car: 'car',
  internationalFlight:'international_flight',
  internationalHotel:'international_hotel'
}

export const NeedCardType = {
  yes: '1',
  no: '0'
}

export const UserLabelType = {
  self: 1, // 本人
  employee: 2, // 员工
  self_employee: 3 // 本人加员工
}

export const ContactType = {
  history: '0', // 历史联系人
  common: '1', // 常用联系人
  all: '2' // 全部
}

// export const TravelType = {
export const SceneType = {
  forBusiness: '1', // 因公
  forPersonal: '2'  // 因私
}

// 页面来源
export const PageSource = {
  common: '1',    // 常用
  select: '2'     // 选择
}

// 业务类型
export const BusinessType = {
  self: '1',       // 本人
  other: '2',      // 他人
  both: '3',       // 本人+他人
}

// 审批类型
export const ApprovalType = {
  no: '0',      // 无须审批
  yes: '1'      // 需要审批
}

// 制度业务类型
export const RuleType = {
  hotel: 3,
  train: 4,
  flight: 6,
  all: 0,
}

// 出行人类型
export const SubTypeConst = {
  member: '1',
  company_business: '2',
  self_business: '3',
  self_personal: '4',
}

// 员工状态
export const EmployeeStatus = {
  normal: '1',
  leave: '4',
}

// 截止时间
export const DeadLineList = [
  {
    hour: 24,
    text: '发车前1天'
  },
  {
    hour: 3,
    text: '发车前3小时'
  },
  {
    hour: 2,
    text: '发车前2小时'
  },
  {
    hour: 1,
    text: '发车前1小时'
  },
  {
    hour: 0.5,
    text: '发车前半小时'
  }
];